<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="halftitlepage" id="bkht">
<h1 class="bkht">Saint Peter and the Goldfinch</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-ridl-0003.vue?7d7f1736